import React from 'react'
import moment from 'moment'
import Image, { SIGNATURE_PLACEHOLDER, IMAGE_PLACEHOLDER } from './Image'
import Footer from '../controls/Footer'

class ShowPrint extends React.Component {

  constructor(props){
    super(props)
  }
  
 

render(props) {
     const record= this.props.record
     const classes = this.props.classes
     return(
        <div className={classes.root}>
            <table className={classes.tableOuter} >
            <tbody>
            <tr>
                <td>
                <div className={classes.title}>DONOR PHYSICAL EXAM FORM</div>
                <table className={classes.tableNoBorder} cellPadding="5">
                    <tbody>               
                    <tr>
                        <td><b>CENTER:</b>&nbsp;&nbsp;&nbsp;{record.location}</td>
                        <td><b>TYPE:</b>&nbsp;&nbsp;&nbsp;{record.type}</td>
                    </tr>
                    <tr>
                        <td ><b>DONOR NAME:</b>&nbsp;&nbsp;&nbsp;{record.last_name + ',  ' + record.first_name + '  ' + ((record && record.middle_name )?  record.middle_name : '' )}</td>
                        <td><b>DONOR #:</b>&nbsp;&nbsp;&nbsp;{record.ssn}</td>
                    </tr>
                    <tr>
                        <td><b>Auditor Present During Physical Donor Consent:</b>&nbsp;&nbsp;&nbsp;{record.auditor}</td>
                        <td><b>Donor Initial:</b>&nbsp;&nbsp;&nbsp;{record.donor_init}</td>
                    </tr>
                    <tr>
                        <td><b>Chaperone Offered?</b>&nbsp;&nbsp;&nbsp;{record.chap_offered}</td>
                        <td colSpan='3'>{record.comments}<br/></td>
                    </tr>
                    </tbody>
                </table>
                </td>
            </tr>
            <tr>
                <td>
                <table className={classes.table} border="1" cellPadding="5">
                    <tbody >
                    <tr>
                        <td style={{width:'20px'}}></td><th >WNL/Abnormal</th><th>Examination of Anatomical Area</th>
                    </tr>
                    <tr>
                        <td>1</td><td className={classes.textCenter}>{record.appearance}</td><td><b>General appearance:</b>&nbsp;Awake, alert and oriented and in no apparent distress, emotionally stable.</td>
                    </tr>
                    <tr>
                        <td>2</td><td className={classes.textCenter}>{record.head}</td><td><b>{'Head:'}</b>{'Normocephalic, atraumatic, symmetrical, no scars.'}</td>
                    </tr>
                    <tr>
                        <td>3</td><td className={classes.textCenter}>{record.eyes}</td><td><b>{'Eyes:'}</b>{'White conjunctiva, pupils equal round and reactive to light and accommodation, extraocular muscles intact bilaterally. No sclera icterus.'}</td>
                    </tr>
                    <tr>
                        <td>4</td><td className={classes.textCenter}>{record.ears}</td><td><b>{'Ears:'}</b>{'Symmetrical without any tenderness, discharged or erythema in external canals bilaterally. Tympanic memberanes are clear without any erythema bilaterally.'}</td>
                    </tr>
                    <tr>
                        <td>5</td><td className={classes.textCenter}>{record.nose}</td><td><b>{'Nose:'}</b>{'Symmetrical without any tenderness or discharge. No inflammation or nasal mucosa bilaterally. No septal perforation.'}</td>
                    </tr>
                    <tr>
                        <td>6</td><td className={classes.textCenter}>{record.mouth}</td><td><b>{'Mouth and Throat:'}</b>{'Clear without erythema or exudates in posterior oropharynx. Pink mucosa on tongue and tonsils (if present). No ulcerations or needle marks present.'}</td>
                    </tr>
                    <tr>
                        <td>7</td><td className={classes.textCenter}>{record.neck}</td><td><b>{'Neck /Lymphatic:'}</b>{'No scars noted. No masses palpated. No thyromegaly. No enlarged or tender nodules. No cervical, posterior auricular or supraclavicular lymphadenopathy.  No axillary adenopathy.'}</td>
                    </tr>
                    <tr>
                        <td>8</td><td className={classes.textCenter}>{record.heart}</td><td><b>{'Heart:'}</b>{'Regular rate and rhythm with no murmurs, gallops, rubs or clicks. No additional heart sounds.'}</td>
                    </tr>
                    <tr>
                        <td>9</td><td className={classes.textCenter}>{record.lungs}</td><td><b>{'Lungs:'}</b>{'Clear to auscultation in all fields bilaterally. No wheezes, rales or rhonchi.'}</td>
                    </tr>
                    <tr>
                        <td>10</td><td className={classes.textCenter}>{record.abdomen}</td><td><b>{'Abdomen:'}</b>{'No scars noted. Soft, non-tender. No guarding or rebound tenderness. No palpable masses. No hepato-splenomegaly.'}</td>
                    </tr>
                    <tr>
                        <td>11</td><td className={classes.textCenter}>{record.neurological}</td><td><b>{'Neurological:'}</b>{'Normal gait and balance. No tremors. Mental status and speech appropriate. Deep tendon reflexes are symmetric bilaterally. No facial asymmetries.'}</td>
                    </tr>
                    <tr>
                        <td>12</td><td className={classes.textCenter}>{record.muscul}</td><td><b>{'Musculoskeletal/Extremities:'}</b>{'No obvious deformities noted.  No edema.'}</td>
                    </tr>
                    <tr>
                        <td>13</td><td className={classes.textCenter}>{record.skin}</td><td><b>{'Skin:'}</b>{'No suspicious needle marks. No suspicious lesions. No infections, rashes, bruises, scarring or masses.'}</td>
                    </tr>
                    <tr>
                        <td colSpan='3'><b>Comments:&nbsp;&nbsp;&nbsp;</b>{record.physical_exam_comments}</td>
                    </tr>
                </tbody>
            </table>
            </td>
          </tr>
          <tr>
              <td>
                <table className={classes.tableNoBorder}  cellPadding="5">
                    <tbody>
                        <tr>
                            <td><b>High Risk Assessment Quiz Completed   Initial:</b>&nbsp;&nbsp;&nbsp;{record.quiz_comp_initial}</td>
                            <td><b>Donor Suitable for Donation?</b>&nbsp;&nbsp;&nbsp;{record.suitable}</td>
                            <td><b>Initial/Date:</b>&nbsp;&nbsp;&nbsp;{record.suitable_initial}&nbsp;&nbsp;&nbsp;{((record.suitable_date)? moment(record.suitable_date).format('MM/DD/YYYY') : '') }</td>
                        </tr>
                        <tr>
                            <td><b>Donor Signature:</b>&nbsp;&nbsp;&nbsp;<Image
                                                                            src={record.quiz_don_sign}
                                                                            fallbackSrc={SIGNATURE_PLACEHOLDER}
                                                                            alt="Donor signature"
                                                                            className={classes.signature}
                                                                            name= "donor_signature"
                                                                            />
                            </td>
                            <td><b>Examinor's Signature:</b>&nbsp;&nbsp;&nbsp;<Image
                                                                            src={record.quiz_exam_sign}
                                                                            fallbackSrc={SIGNATURE_PLACEHOLDER}
                                                                            alt="Examiner signature"
                                                                            className={classes.signature}
                                                                            name= "examiner_signature"
                                                                            />
                            </td>
                            <td><b>Date:</b>&nbsp;&nbsp;&nbsp;{((record.quiz_exam_date)? moment(record.quiz_exam_date).format('MM/DD/YYYY') : '') }</td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr>
        </tbody>
        </table>
        <table className={classes.tableOuterPrint}  style={{height:"405px"}}>
            <tr>
                <td></td>
            </tr>
        </table>
        <Footer >
            <span>Edonorsoft SOP Form No. 01.01.01, Effective 02-16-15</span>
        </Footer>
        
        

      <table className={classes.tableOuter}>
          <tbody>
            <tr>
                <td>
                    <div className={classes.title}>DONOR PHYSICAL EXAM FORM</div>
                    <div className={classes.subHeading}>Tattoo/Body Piercing Location Documentation</div>
                
                    <table className={classes.tableNoBorder} cellPadding="5">
                    <tbody>               
                        <tr>
                            <td>DONOR NAME:&nbsp;&nbsp;&nbsp;{record.last_name + ',  ' + record.first_name + '  ' + ((record && record.middle_name )?  record.middle_name : '' )}</td>
                            <td>DONOR #:&nbsp;&nbsp;&nbsp;{record.ssn}</td>
                        </tr>
                        <tr>
                            <td colSpan='2'>
                                <Image
                                    className={classes.img}
                                    src={record.tattoo_img_url}
                                    fallbackSrc={IMAGE_PLACEHOLDER}
                                    alt="Tattoo / body piercing body map"
                                />
                                
                            </td>
                        </tr>
                        <tr>
                            <td colSpan='2'>DESCRIPTION:&nbsp;&nbsp;&nbsp;{record.tattoo_desc} </td>
                        </tr>
                        <tr>
                            <td colSpan='2'>&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan='2'>
                            <b>{'Donor Verification Statment:'}</b>{'This body map is an accurate representation of all my piercings (including closed piercings) gauging, '
                        + 'and/or tattoos, touch ups and/or brandings, and scarifications.  I agree to notify center staff if I receive any new tattoos, piercings, gauging,  brandings, or scarifications.'}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <table className={classes.tableNoBorder} cellPadding="5">
                                    <tbody>
                                        <tr>
                                            <td>Donor's signature:&nbsp;&nbsp;&nbsp;
                                                <Image
                                                src={record.desc_don_sign}
                                                fallbackSrc={SIGNATURE_PLACEHOLDER}
                                                alt="Donor signature"
                                                className={classes.signature}
                                                name= "donor_signature"
                                                /></td>
                                            <td>Examiner signature:&nbsp;&nbsp;&nbsp;
                                                <Image
                                                src={record.desc_exam_sign}
                                                fallbackSrc={SIGNATURE_PLACEHOLDER}
                                                alt="Examiner signature"
                                                className={classes.signature}
                                                name= "examiner_signature"
                                                /></td>
                                            <td>Date:&nbsp;&nbsp;&nbsp;{((record.desc_exam_date)? moment(record.desc_exam_date).format('MM/DD/YYYY') : '') } </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                    </table>
                </td>
            </tr>
          </tbody>
        </table>
        <Footer >
            <span>Edonorsoft SOP Form No. 01.01.01, Effective 02-16-15</span>
        </Footer>
        <div className={classes.pagebreak}></div>

        <table className={classes.tableOuter}>
          <tbody>
            <tr>
                <td>
                <div className={classes.title}>DONOR PHYSICAL EXAM MEDICATION FORM</div>
                <table className={classes.table} border="1" cellPadding="5">
                    <tbody>
                        <tr>
                            <th>Medication Name</th><th>Medication Acceptable YES/NO</th><th>Start Date</th><th>Initial/Date</th><th>Stop Date</th><th>Initial/Date</th><th>Comments</th><th>QA Review</th>
                        </tr>
                        {
                            record.medications && record.medications.map && record.medications.map(function (medication) {
                                return (
                                    <tr>
                                        <td>{medication.med_name}</td>
                                        <td>{(medication.med_accept)?'YES' : 'NO'}</td>
                                        <td>{((medication.med_s_date)? moment(medication.med_s_date).format('MM/DD/YYYY') : '') }</td>
                                        <td>{medication.med_s_init}&nbsp;&nbsp;{((medication.med_s_init_date)? moment(medication.med_s_init_date).format('MM/DD/YYYY') : '')}</td>
                                        <td>{((medication.med_e_date)? moment(medication.med_e_date).format('MM/DD/YYYY') : '')}</td>
                                        <td>{medication.med_e_init}&nbsp;&nbsp;{((medication.med_e_init_date)? moment(medication.med_e_init_date).format('MM/DD/YYYY') : '')}</td>
                                        <td>{medication.med_comments}</td>
                                        <td>{medication.med_qa_review}</td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
                <table className={classes.tableNoBorder} cellPadding="5">
                    <tbody>               
                    <tr>
                        <td ><b>DONOR NAME:</b>&nbsp;&nbsp;&nbsp;{record.last_name + ',  ' + record.first_name + '  ' + ((record && record.middle_name )?  record.middle_name : '' )}</td>
                        <td><b>DONOR #:</b>&nbsp;&nbsp;&nbsp;{record.ssn}</td>
                    </tr>
                    <tr>
                        <td><b>Donor Suitable for Donation:</b>&nbsp;&nbsp;&nbsp;{record.suitable}</td>
                        <td><b>Initial / Date:</b>&nbsp;&nbsp;&nbsp;{record.suitable_initial}&nbsp;&nbsp;{((record.suitable_date)? moment(record.suitable_date).format('MM/DD/YYYY') : '')}</td>
                    </tr>
                    <tr>
                        <td><b>QA Reviwe Initial</b>&nbsp;&nbsp;&nbsp;{record.med_qa_init}</td>
                        <td><b>Date:</b>&nbsp;&nbsp;&nbsp;{((record.med_qa_date)? moment(record.med_qa_date).format('MM/DD/YYYY') : '')}</td>
                    </tr>
                    </tbody>
                </table>
                </td>
            </tr>
            </tbody>
        </table>
        <Footer >
            <span>Edonorsoft SOP Form No. 01.01.01, Effective 02-16-15</span>
        </Footer>
    </div>
     )
    }
}

export default ShowPrint